import { render, staticRenderFns } from "./ContasFesta.vue?vue&type=template&id=49e08dc4&"
import script from "./ContasFesta.vue?vue&type=script&lang=js&"
export * from "./ContasFesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports